export const yotpoMixin = {
  methods: {
    //toggles truncated reviews/questions with 'Read More' or 'Read Less'
    expandDescription(content) {
      if (content.expanded) {
        content.expanded = false;
      } else {
        content.expanded = true;
      }
    },

    translateAllpaComfortLevel(integerValue){
      switch (integerValue) {
        case 1:
          return 'Some discomfort';
        case 2:
          return 'Comfort is as expected';
        case 3:
          return 'Very comfortable';
        default:
          return '';
      }
    },

    //validates that all required form fields are filled
    validateForm(form) {
      //name required
      if (!form.display_name) {
        this.formErrors.displayName = 'Please enter your name.';
      } else {
        this.formErrors.displayName = null;
      }

      //valid email required
      if (!form.email) {
        this.formErrors.email = 'Please enter your email.';
      } else if (!this.validEmail(form.email)) {
        this.formErrors.email = 'Please enter a valid email.';
      } else {
        this.formErrors.email = null;
      }

      //content required
      if (!form.review_content) {
        this.formErrors.content = 'Please add content.';
      } else {
        this.formErrors.content = null;
      }

      //additional requried fields on the review form
      if (form == this.reviewForm) {
        //review score required
        if (!form.review_score) {
          this.formErrors.rating = 'Please rate this item.';
        } else {
          this.formErrors.rating = null;
        }

        //review title required
        if (!form.review_title) {
          this.formErrors.title = 'Please title your review.';
        } else {
          this.formErrors.title = null;
        }

        //submit review if all required fields are filled
        if (
          form.display_name &&
          this.validEmail(form.email) &&
          form.review_title &&
          form.review_content &&
          form.review_score
        ) {
          this.postReview();
        }
      }

      //submit question if all required fields are filled
      if (form == this.questionForm) {
        if (
          form.display_name &&
          this.validEmail(form.email) &&
          form.review_content
        ) {
          this.postQuestion();
        }
      }
    },

    //ensures email address on submit review/ask question forms follows correct pattern
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    //closes submit review/ask question form
    closeForm() {
      this.reviewSubmitted = false;
      this.$emit('closeForm', false);
    },

    //resets form after submit
    resetForm(form) {
      if (form === 'review') {
        this.reviewForm = Object.assign({}, this.reviewForm, {
          display_name: '',
          email: '',
          review_title: '',
          review_content: '',
          review_score: 0,
          custom_fields: Object.assign({}, this.reviewForm.custom_fields, {
            '--51722': null,
          }),
        });
      } else {
        this.questionForm = Object.assign({}, this.questionForm, {
          display_name: '',
          email: '',
          review_content: '',
        });
      }
    },
  },
};
